import { LVG_ASSETS } from 'constants/games/lvg/lvgAssets'
import { useLvgOrdersList } from 'hooks/games/lvg/useLvgOrders'
import { useLvgState } from 'hooks/games/lvg/useLvgState'
import React, { useEffect } from 'react'
import { GamePlayArea, GamePlayStats } from '../SaredComponents/SharedComponent'
import InfiniteLeaderboard from './InfiniteLeaderboard/InfiniteLeaderboard'
import { useFetchLeaderboardData } from './InfiniteLeaderboard/Tabs/Leaderboard/hooks/useFetchLeaderboardData'
import { LvgGraph } from './LvgGraph'
import { SingleContentToggle } from 'components/Atoms/SingleContentToggle'
import { ASSETS_TYPES } from 'constants/assets'
import { isStockMarketOpen } from 'utils'
import { LvgStockMarketClosed } from './LvgStockMarketClosed'
import { useUser } from 'hooks/user/useUser'
import { isEmpty } from 'lodash'
import { LvgGameHeader } from 'components/Organisms/MainGames/Leverage/LvgGameHeader'

const DEFAULT_STOCK_ASSET_NAME = 'SPY'
const DEFAULT_CRYPTO_ASSET_NAME = 'BTC/USD'

const InfiniteWinning = (props) => {
  const { lastSelectedAssets } = useUser('preferences')
  const orderList = useLvgOrdersList()
  const { leaderboardData, LeaderboardSortBy } = useFetchLeaderboardData()

  const { activeAsset, setActiveAsset } = useLvgState()

  useEffect(() => {
    const defaultAssetName = isStockMarketOpen().state ? DEFAULT_STOCK_ASSET_NAME : DEFAULT_CRYPTO_ASSET_NAME
    const defaultAsset = LVG_ASSETS.filter((asset) => asset.id === defaultAssetName)
    setActiveAsset(lastSelectedAssets && !isEmpty(activeAsset) ? activeAsset : defaultAsset.at(0) || LVG_ASSETS.at(0))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const isMarketClose = activeAsset.hasTime && !isStockMarketOpen().state
  const marketCloseReason = (isMarketClose && isStockMarketOpen().reason) || {}

  return (
    <>
      <GamePlayArea>
        <LvgGameHeader />
        <SingleContentToggle
          noWrapper
          toggle={isMarketClose}
          trueContent={<LvgStockMarketClosed title={marketCloseReason.title} subtitle={marketCloseReason.subtitle} />}
          falseContent={<LvgGraph />}
        />
      </GamePlayArea>
      <GamePlayStats>
        <InfiniteLeaderboard data={orderList} leaderboardData={leaderboardData} LeaderboardSortBy={LeaderboardSortBy} />
      </GamePlayStats>
    </>
  )
}

export default InfiniteWinning
